<template>
<div class="open-message">
    <div class="message-title">
      <div class="message-logo">新消息</div>
    </div>
    <div class="message-list" v-if="loaded && messageList && messageList.length > 0">
      <div class="list-items" v-for="(item, index) in messageList" :key="index">
        <div class="item-title">{{item.title}}</div>
        <div class="item-createtime">{{DateUtils.format(new Date(item.createtime), DateFormat.DEFAULT)}}</div>
        <div class="item-content">{{item.content}}</div>
      </div>
    </div>
    <div class="no-message" v-if="loaded && (messageList == null || messageList.length <= 0)">
      <div class="no-message-icon">目前还没有任何消息。</div>
    </div>
</div>

</template>
<script>
import api from '@/common/api';
import DateUtils from '@/common/DateUtils';
const DateFormat = DateUtils.DateFormat;
export default {
  name: 'message',
  data() {
    return {
      messageList: [],
      loaded: false,
      DateUtils,
      DateFormat
    };
  },
  methods: {
    getMessageList() {
      this.$loader.get(api.message.MESSAGE, null, this.messageCallback).then((res) => {
        // this.messageList = (res && res.items) || [];
        this.messageList = [];
        this.loaded = true;
      });
    },
    messageCallback(error) {
      this.loaded = true;
      error.stopPropagation();
      console.warn(error);
    }
  },
  created() {
    this.getMessageList();
  }
};
</script>
<style lang="less">
.open-message{
  .message-title{
    position: relative;
    padding: 30px 0 24px 0px;
    .message-logo{
      display: inline-block;
      height: 36px;
      line-height: 36px;
      background: url(./img/icon_notice.png) no-repeat 0 center;
      padding-left: 42px;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #666666;
    }
  }
  .message-list{
    .list-items{
      box-shadow: 1px 1px 16px 0px rgba(0, 0, 0, 0.16);
      box-sizing: border-box;
      width: 1170px;
      padding: 25px 27px 28px;
      font-size: 15px;
      margin-bottom: 30px;
      .item-title{
        font-size: 18px;
        color: #333333;
        font-weight: normal;
        line-height: 30px;
      }
      .item-createtime{
        line-height: 30px;
        color: #8cc0ff;
        background: url(./img/icon_calendar.png) no-repeat 0px;
        padding-left: 40px;
      }
      .item-content{
        margin-top :10px;
        color:#999999;
      }
    }
  }
  .no-message{
    .no-message-icon{
      width: 1170px;
      max-height: 800px;
      padding-top: 350px;
      text-align: center;
      font-size: 14px;
      color: #999999;
      line-height: 1.8;
      background: url(./img/icon_empty.png) no-repeat center 150px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/open/panels/application/panels/NewMessage.vue